import { SAVE_CONTACT_SNAPSHOT, CLEAR_CONTACT_SNAPSHOT } from '../actions/insuredActions';

const initialState = {
    previewSnapshot: null
};

export default function insuredReducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_CONTACT_SNAPSHOT:
            return { ...state, previewSnapshot: action.payload };
        case CLEAR_CONTACT_SNAPSHOT:
            return { ...state, previewSnapshot: null };
        default:
            return state;
    }
}